import { createAction, props } from '@ngrx/store';
import { ErrorMessage } from '../error/error-message.model';
import { AgenasDisciplineType } from './agenas-discipline.model';

export const loadAgenasDiscipline = createAction('[AgenasDiscipline] LoadAgenasDiscipline');

export const loadAgenasDisciplineSuccess = createAction(
  '[AgenasDiscipline] loadAgenasDisciplineSuccess',
  props<{ datiAgenasDiscipline: AgenasDisciplineType[] }>()
);
export const loadAgenasDisciplineFailure = createAction(
  '[AgenasDiscipline] loadAgenasDisciplineFailure',
  props<{ error: ErrorMessage }>()
);
